module.exports = __webpack_public_path__ + "static/media/LOGO_OPERATOR.2c900585.png";